import { motion } from "framer-motion";
import { MapPin } from "lucide-react";
import { OFFICES } from "../../data";

export default function Locations() {
  return (
    <section id="locations" data-testid="locations-section" className="py-24 md:py-36 border-t border-[#27272a]">
      <div className="mx-auto max-w-[1500px] px-5 md:px-10">
        <div className="mb-14 flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="font-mono text-[11px] tracking-[0.3em] uppercase text-[#ff4500]">/ 04 — Find us</span>
            <h2 className="mt-5 font-heading font-black uppercase tracking-tighter leading-none text-4xl md:text-6xl text-[#f4f4f5]">
              Providing services<br />all over India.
            </h2>
          </div>
          <p className="max-w-xs text-[#8e8e93] font-light leading-relaxed">
            Headquartered in Akola with branches across the region — and{" "}
            <span className="text-[#f4f4f5]">operating throughout India.</span>
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-px bg-[#27272a] border border-[#27272a]">
          {OFFICES.map((o, i) => (
            <motion.div
              key={o.city}
              data-testid={`office-${i}`}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, ease: [0.22, 1, 0.36, 1], delay: i * 0.1 }}
              className="group bg-[#111111] hover:bg-[#1a1a1a] transition-colors duration-500 p-8 md:p-10 min-h-[260px] flex flex-col justify-between"
            >
              <div className="flex items-center justify-between">
                <span className="font-mono text-[10px] tracking-[0.2em] uppercase text-[#8e8e93] border border-[#27272a] px-3 py-1">
                  {o.tag}
                </span>
                <MapPin size={22} className="text-[#8e8e93] group-hover:text-[#ff4500] transition-colors duration-400" />
              </div>
              <div>
                <h3 className="font-heading font-black uppercase tracking-tighter text-4xl md:text-5xl text-[#f4f4f5] mb-4">
                  {o.city}
                </h3>
                <p className="text-[#8e8e93] text-sm font-light leading-relaxed">{o.address}</p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
